// Get the current URL
const currentUrl = window.location.href;
// Check if the current URL is the desired one
if (currentUrl === 'https://www.lasermed.ch/apps/wishlist' || currentUrl === 'https://www.lasermed.ch/apps/wishlist/') {
  // Save a reference to the original XMLHttpRequest object
  var originalXhr = window.XMLHttpRequest;
  // Override the XMLHttpRequest object
  window.XMLHttpRequest = function () {
    var xhr = new originalXhr();
    // Save the original open and send methods
    var originalOpen = xhr.open;
    var originalSend = xhr.send;
    
    // Override the open method
    xhr.open = function (method, url) {
      // Save the URL for later use
      xhr.interceptedUrl = url;
      // Call the original open method
      originalOpen.apply(xhr, arguments);
    };
  
    // Override the send method
    xhr.send = function (data) {
      // Get the current request URL
      // Modify the input parameters only for the desired URL(s)
      if (xhr.interceptedUrl == '/cart/add.js' && xhr.readyState === 1) {
         let jsonData = JSON.parse(data);
         let variant_id = jsonData.items[0].id;
         var variantElement = document.getElementById("variant_" + variant_id);
        
         if(variantElement) {
           var priceItemDiscount = variantElement.getAttribute("data-price_item_discount");
           jsonData.items[0].properties._price_item_discount = priceItemDiscount;
         }
         originalSend.call(this, JSON.stringify(jsonData));
         return;
      }
    
      // Save a reference to the onload function
      var originalOnLoad = xhr.onload;
    
      // Override the onload function
      xhr.onload = function () {
        // Call the original onload function
        if (originalOnLoad) {
          originalOnLoad.apply(xhr, arguments);
        }
  
        // Check if the intercepted URL matches the one you want and the readyState is 4 (request complete)
        if (xhr.interceptedUrl.includes('/apps/wishlist/data?userid=' + aico.login_customer_id) && xhr.readyState === 4) {
          let response_data = JSON.parse(xhr.response);
          let aico_price_object = {};
          let productData = response_data.data;
          productData.map((value, index) => {
          async function fetchData() {
              try {
                  var proData = await getCollectionAndVendor(value.id);
                  aico_price_object.vendor = proData.data.node.product.vendor;
                  aico_price_object.price = value.price;
                  aico_price_object.compare_price = "";
                  aico_price_object.aico_product_collections = '';

                  let collections_list = proData.data.node.product.collections.edges;
                  var aico_product_collections=[];
                  collections_list.map((val, index) => {
                     aico_product_collections.push(val.node.handle);
                  }); 
                
                  var aico_product_collections_string = aico_product_collections.toString();
                  aico_price_object.aico_product_collections=aico_product_collections_string;
                  var variant_meta='';
                  if(proData.data.node.metafield != null){
                      variant_meta = JSON.parse(proData.data.node.metafield.value);
                  } else if (proData.data.node.product.metafield != null) {
                      variant_meta = JSON.parse(proData.data.node.product.metafield.value);
                  } else {
                      //console.log('Product metafield null');
                  }
                  if(variant_meta != ''){
                    aico_price_object.price_list_data= variant_meta;
                  }
                  var discount_price = aico_get_price_list_price({[value.product.handle]:aico_price_object});
                  // if(discount_price.price_list_price >= value.price){
                  //   return;
                  // }
                  // console.log("discount_price", discount_price);
                  var thumbLinkElements = document.getElementsByClassName('thumb-link');
                  for (var i = 0; i < thumbLinkElements.length; i++) {
                      var thumbLinkElement = thumbLinkElements[i];
                      var hrefValue = thumbLinkElement.getAttribute('href');
                      if(hrefValue == `/products/${value.product.handle}?variant=${v_id}`){
                          let price_formatted=parseFloat(discount_price.price_list_price).toLocaleString(window.Shopify.locale+"-"+window.Shopify.country,{style:'currency',currency:Shopify.currency.active});
                          let priceElement = thumbLinkElement.closest('.uwl-product-single-wrap');
        
                          if (priceElement) {
                            // Find child elements with class 'product-price' and 'span'
                             var productPriceSpanElements = priceElement.querySelectorAll('.product-price span');
                             var productPriceOriginal = priceElement.querySelectorAll('.product-price del');
                             var priceItemDiscountElement = priceElement.querySelectorAll('.product-price');

                             priceItemDiscountElement.forEach(function (priceItemDiscountElementSingle) {
                                  priceItemDiscountElementSingle.setAttribute('id', "variant_"+v_id)
                                  priceItemDiscountElementSingle.setAttribute('data-price_item_discount', discount_price.price_list_price)
                              });
                             
                              // Loop through the child elements and update their HTML content
                              productPriceSpanElements.forEach(function (spanElement) { spanElement.innerHTML = price_formatted;}); 
                              let org_price_formatted=parseFloat(value.price).toLocaleString(window.Shopify.locale+"-"+window.Shopify.country,{style:'currency',currency:Shopify.currency.active});
                              if(productPriceOriginal.length) {
                                 productPriceOriginal.forEach(function (delElement) { delElement.innerHTML = org_price_formatted;});      
                              } else {
                                if(discount_price.price_list_price >= value.price){
                                  productPriceSpanElements.forEach(function (spanElement) { spanElement.innerHTML = org_price_formatted;});
                                }else{
                                  var newDiscountElement = document.createElement("del");
                                 newDiscountElement.innerHTML = org_price_formatted;
                                 productPriceSpanElements.forEach(function (spanElement) {
                                 spanElement.insertAdjacentElement("afterend", newDiscountElement);
                                   spanElement.insertAdjacentHTML("afterend", " - ");
                                 }); 
                               }
                                 
                              }
                          }
                      }
                  }
              } catch (error) {
                console.error('Error fetching data:', error);
              }
            }
            
            fetchData();
            var variantGid = value.id;
            variantGid = variantGid.split('/');
            var v_id = variantGid[variantGid.length - 1];
          });
        }
      };
      // Call the original send method
      originalSend.apply(xhr, arguments);
    };
  
    return xhr;
  };

}

  async function getCollectionAndVendor(id) {
   
       const query = `
	        query {
	            node(id: "${id}") {
	                ... on ProductVariant {
	                    product {
	                        id
	                        metafield(namespace: "custom_fields", key: "price_list_data") {
	                        key
	                        value
	                    } 
	                        vendor
	                        handle
	                        collections(first: 250) {
	                            edges {
	                                node {
	                                    id
	                                    title
	                                    handle
	                                }
	                            }
	                        }
	                    }
	                    price {
	                        amount
	                        currencyCode
	                    }
	                    metafield(namespace: "custom_fields", key: "price_list_data") {
	                        key
	                        value
	                    }
	                }
	            }
	        }
	    `;

        try {
            const response = await fetch(origin+"/api/2023-07/graphql.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": '79ce4cff8542be66f63d51a0f0c234d9',
                },
                body: JSON.stringify({ query }),
            });

            const data = await response.json();
            return data;
        } catch (error) {
	        console.log('Error while fetching ProductVariant data',error);
	        throw error; 
	        
	    }
  
	}